import { render, staticRenderFns } from "./seekHelp.vue?vue&type=template&id=647ea31a&scoped=true"
import script from "./seekHelp.vue?vue&type=script&lang=js"
export * from "./seekHelp.vue?vue&type=script&lang=js"
import style0 from "./seekHelp.vue?vue&type=style&index=0&id=647ea31a&prod&lang=css"
import style1 from "./seekHelp.vue?vue&type=style&index=1&id=647ea31a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647ea31a",
  null
  
)

export default component.exports